_.deepObjectExtend = function(target, source) {
  // imho this makes little sense, but it is supposed to be better.
  return $.extend(true, target, source);
};
